export default "__VITE_ASSET__DuHHM1YQ__"